import ThumbnailSkeleton from './ThumbnailSkeleton';

export default ThumbnailSkeleton;
